import Inquiry from "./branch/Inquiry";
import Notice from "./branch/Notice";
import PT from "./branch/PT";
import Student from "./branch/Student";
import Teacher from "./branch/Teacher";

const Branch = () => {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <Student />
          <PT />
          <Teacher />
        </div>
        <div className="col-6">
          <Notice />
          <Inquiry />
        </div>
      </div>
    </>
  );
}

export default Branch;
